// Cliente HTTP mínimo del backoffice. Siempre /api relativo: en dev lo proxya
// Vite (vite.config.ts) y en prod el nginx del contenedor.
const BASE_URL = import.meta.env.VITE_API_URL ?? '/api';

export interface ApiError extends Error {
  status?: number;
  code?: string;
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const hasJsonBody = init?.body != null;
  const res = await fetch(`${BASE_URL}${path}`, {
    credentials: 'include',
    headers: hasJsonBody ? { 'Content-Type': 'application/json', ...init?.headers } : init?.headers,
    ...init,
  });
  if (!res.ok) {
    let code: string | undefined;
    let message = `Error ${res.status}`;
    try {
      const body = await res.json();
      code = body.error;
      message = body.message ?? body.error ?? message;
    } catch {
      /* respuesta sin cuerpo JSON */
    }
    const err = new Error(message) as ApiError;
    err.status = res.status;
    err.code = code;
    throw err;
  }
  return res.json() as Promise<T>;
}

/** "23 ene 2025" — mismo formato que el resto de apps de José. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** Enteros con separador de miles en locale español. */
export function fmtNum(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString('es-ES');
}

/** Enlace a la ficha pública del punto en la app del mapa. */
export function pointUrl(shareCode: string | null): string | null {
  return shareCode ? `https://app.bestigium.com/point/${shareCode}` : null;
}
